/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'CLAIM_TRANSACTION',
  'CREATE_ACTIVITY_WITHDRAW_TRANSACTION',
  'CREATE_TRANSACTION',
  'LOAD_TRANSACTIONS',
]);



// WEBPACK FOOTER //
// ./src/payments/constants/TransactionConstants.js